/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

export class Constants {
    
    public static readonly FILL_PROPERTY = 'fill';
    
    public static readonly DRAW_PROPERTY = 'draw';
    
    public static readonly FONT_PROPERTY = 'font';
    
    public static readonly BLUR_PROPERTY = 'blur';
    
}
